import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";
import { Icon } from "Components";
import Alert from "PhishingManager/components/Alert";
import { Steps } from "antd";

const { Step } = Steps;

const TestCampaignModal: React.FC<ModalProps & { testEmailsCount: number }> = ({
    testEmailsCount,
    open,
    onClose,
    onConfirm,
}) => {
    return (
        <CommonModal
            visible={open}
            cancelText={null}
            confirmText="View campaign status"
            parentClass='test-campaign-modal'
            iconType={null}
            onClose={onClose}
            onConfirm={onConfirm}>
            <div className="pm-icon-box">
                <div className="pm-icon-wrapper">
                    <Icon type={"check"} />
                </div>
            </div>
            <p className="pm-modal-title-text">Test started successfully</p>
            <p>Test emails are being delivered. Review results before releasing.</p>
            <div className="campaign-status-container">
                <span>What happens next</span>
                <Steps direction="vertical" current={1}>
                    <Step
                        icon={null}
                        title="Test emails sent"
                        description={`Delivering to ${testEmailsCount} test recipients`}
                    />
                    <Step
                        icon={<Icon type={"stepInProgress"} />}
                        title="Review results"
                        description="Check if the email tests were received"
                    />
                    <Step
                        title="Release full campaign"
                        description="Send to all recipients"
                    />
                </Steps>
            </div>
            <Alert iconType="phishingManagerWarningModal" title="Didn't receive the test?"
                subtitle="Review and update your whitelisting configuration, then re-send the test from the Phishing Manager." />
        </CommonModal>
    );
};

export default TestCampaignModal;